import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { register } from '../redux/auth/authActions';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { fetchProgramList, getRoles, fetchSubProgramId, fetchProgramById,
  fetchProgramId, uploadbellNofifications, findUserByEmail, sendEmailNotification } from '../redux/actions/Actions';
import FormValidator from '../common/FormValidator';
import { assets } from '../../assets/assets';

const RegisterForm = () => {
  const dispatch  = useDispatch();
  const navigate  = useNavigate();
  const location  = useLocation();

  const allRole           = useSelector((s) => s.getAllRoles.roles);
  const fetchPrograms     = useSelector((s) => s.fetchAllPrograms.programs);
  const getSubprogramId   = useSelector((s) => s.fetchSubProgramId.subprogramId);

  const [programId,    setProgramId]    = useState('');
  const [subProgramId, setSubProgramId] = useState('');
  const [gradYear,       setGradYear]       = useState('');
  const [errors,         setErrors]         = useState({});
  const [submitted,      setSubmitted]      = useState(false);
  const [showPassword,   setShowPassword]   = useState(false);
  const [pendingBrochure, setPendingBrochure] = useState(
    location.state?.brochureHref
      ? { href: location.state.brochureHref, filename: location.state.brochureFilename }
      : null
  );

  const [formData, setFormData] = useState({
    username: '', password: '', email: '', phone_number: '',
  });
  const { username, password, email, phone_number } = formData;

  useEffect(() => { dispatch(getRoles()); },         [dispatch]);
  useEffect(() => { dispatch(fetchProgramList()); }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((p) => { const n = { ...p }; delete n[name]; return n; });
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleProgramChange = (e) => {
    setProgramId(e.target.value);
    dispatch(fetchProgramById(e.target.value));
    dispatch(fetchSubProgramId(e.target.value));
    dispatch(fetchProgramId(e.target.value));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const ve = {
      username:     FormValidator({ name: 'username',     value: username,     errors }),
      password:     FormValidator({ name: 'password',     value: password,     errors }),
      email:        FormValidator({ name: 'email',        value: email,        errors }),
      phone_number: FormValidator({ name: 'phone_number', value: phone_number, errors }),
      programId:    FormValidator({ name: 'programId',    value: programId,    errors }),
      subProgramId: FormValidator({ name: 'subProgramId', value: subProgramId, errors }),
    };
    if (Object.values(ve).every((e) => !e)) {
      const registerData = { username, email, password, phone_number, subprogram_id: subProgramId, program_id: programId, role_id: 2 };
      dispatch(register(registerData));
      dispatch(uploadbellNofifications({ registerData, number: 1 }));
      setSubmitted(true);
      setFormData({ username: '', password: '', email: '', phone_number: '' });
      setProgramId(''); setSubProgramId(''); setGradYear('');
    } else {
      setErrors(ve);
    }
  };

  return (
    <div style={s.page} className="register-page">
      <style>{`
        @media (max-width: 900px) {
          .register-page  { grid-template-columns: 1fr !important; }
          .register-left  { display: none !important; }
          .register-right { padding: 32px 5% !important; }
          .register-card  { max-width: 100% !important; }
        }
        @media (max-width: 600px) {
          .register-row { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 480px) {
          .register-card { padding: 28px 22px 24px !important; }
        }
      `}</style>
      {/* ── Left panel ── */}
      <div style={s.left} className="register-left">
        <div style={s.leftInner}>
          <img src={assets.logo_img} alt="UPL" style={s.logo} />
          <h2 style={s.leftH}>Start your journey with UPL</h2>
          <p style={s.leftP}>
            Join thousands of learners building industry-grade skills. Get access to live classes, real projects, and expert mentorship.
          </p>
          <div style={s.featureList}>
            {[
              '✦  Industry-grade curriculum',
              '✦  Live mentorship sessions',
              '✦  Job placement support',
              '✦  Real-world projects',
            ].map((f) => (
              <div key={f} style={s.feature}>{f}</div>
            ))}
          </div>
          <div style={s.statsRow}>
            {[{ v:'1k+', l:'Enrolled' }, { v:'50+', l:'Courses' }, { v:'4.8★', l:'Rating' }].map((st) => (
              <div key={st.l} style={s.stat}>
                <div style={s.statV}>{st.v}</div>
                <div style={s.statL}>{st.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Right panel ── */}
      <div style={s.right} className="register-right">
        <div style={s.card} className="register-card">
          <Link to="/" style={s.close}>✕</Link>

          {submitted ? (
            <div style={{ textAlign: 'center', padding: '48px 0' }}>
              <div style={{ fontSize: 52, marginBottom: 12 }}>🎉</div>
              <h3 style={{ color: '#0F172A', fontWeight: 800, fontSize: 22, margin: '0 0 8px' }}>You're in!</h3>
              <p style={{ color: '#64748B', fontSize: 15, marginBottom: 24 }}>
                Registration successful! Check your email to get started.
              </p>

              {pendingBrochure && (
                <div style={{ marginBottom: 20, padding: '16px', background: '#EFF6FF', border: '1px solid #BFDBFE', borderRadius: 10 }}>
                  <p style={{ color: '#1D4ED8', fontSize: 14, fontWeight: 600, margin: '0 0 12px' }}>
                    Your brochure is ready to download!
                  </p>
                  <a
                    href={pendingBrochure.href}
                    download={pendingBrochure.filename}
                    style={{ ...s.btn, textDecoration: 'none', display: 'inline-block', padding: '11px 28px', width: 'auto', background: '#2563EB' }}
                  >
                    Download Brochure
                  </a>
                </div>
              )}

              <Link to="/login" style={{ ...s.btn, textDecoration: 'none', display: 'inline-block', padding: '12px 32px', width: 'auto' }}>
                Go to Login
              </Link>
            </div>
          ) : (
            <>
              <h1 style={s.heading}>Take your career to the next level now!</h1>

              <form onSubmit={handleSubmit} style={s.form}>

                {/* Row 1: Name + Email */}
                <div style={s.row} className="register-row">
                  <div style={s.field}>
                    <input name="username" value={username} onChange={handleChange}
                      placeholder="Enter your full name *" style={s.input}
                      onFocus={e => e.target.style.borderColor='#2563EB'}
                      onBlur={e  => e.target.style.borderColor='#E2E8F0'} />
                    {errors.username && <span style={s.err}>{errors.username}</span>}
                  </div>
                  <div style={s.field}>
                    <input name="email" value={email} onChange={handleChange} type="email"
                      placeholder="Enter your email *" style={s.input}
                      onFocus={e => e.target.style.borderColor='#2563EB'}
                      onBlur={e  => e.target.style.borderColor='#E2E8F0'} />
                    {errors.email && <span style={s.err}>{errors.email}</span>}
                  </div>
                </div>

                {/* Row 2: Phone + Password */}
                <div style={s.row} className="register-row">
                  <div style={s.field}>
                    <div style={s.phoneWrap}
                      onFocus={e => e.currentTarget.style.borderColor='#2563EB'}
                      onBlur={e  => e.currentTarget.style.borderColor='#E2E8F0'}>
                      <span style={s.flag}>IN +91</span>
                      <input name="phone_number" value={phone_number} onChange={handleChange} type="tel"
                        placeholder="Phone number *"
                        style={{ ...s.input, border:'none', outline:'none', flex:1, minWidth:0, background:'transparent', padding:'12px 12px' }} />
                    </div>
                    {errors.phone_number && <span style={s.err}>{errors.phone_number}</span>}
                  </div>
                  <div style={s.field}>
                    <div style={s.eyeWrap}
                      onFocus={e => e.currentTarget.style.borderColor='#2563EB'}
                      onBlur={e  => e.currentTarget.style.borderColor='#E2E8F0'}>
                      <input name="password" value={password} onChange={handleChange}
                        type={showPassword ? 'text' : 'password'}
                        placeholder="Create a password *"
                        style={{ ...s.input, border:'none', outline:'none', flex:1, background:'transparent', padding:'12px 14px' }} />
                      <button type="button" onClick={() => setShowPassword(!showPassword)} style={s.eyeBtn}>
                        {showPassword ? '🙈' : '👁'}
                      </button>
                    </div>
                    {errors.password && <span style={s.err}>{errors.password}</span>}
                  </div>
                </div>

                {/* Row 3: Grad year + Program */}
                <div style={s.row} className="register-row">
                  <div style={s.field}>
                    <input value={gradYear} onChange={e => setGradYear(e.target.value)} type="number"
                      placeholder="Graduation year *" style={s.input} min="2000" max="2030"
                      onFocus={e => e.target.style.borderColor='#2563EB'}
                      onBlur={e  => e.target.style.borderColor='#E2E8F0'} />
                  </div>
                  <div style={s.field}>
                    <select value={programId} onChange={handleProgramChange} style={s.select}>
                      <option value="">Select a program *</option>
                      {fetchPrograms.map((p) => (
                        <option key={p.program_id} value={p.program_id}>{p.program_name}</option>
                      ))}
                    </select>
                    {errors.programId && <span style={s.err}>{errors.programId}</span>}
                  </div>
                </div>

                {/* Subprogram — full width */}
                {getSubprogramId?.length > 0 && (
                  <div style={s.field}>
                    <select value={subProgramId} onChange={e => setSubProgramId(e.target.value)} style={s.select}>
                      <option value="">Select a course *</option>
                      {getSubprogramId.map((sp) => (
                        <option key={sp.subprogram_id} value={sp.subprogram_id}>{sp.subprogram_name}</option>
                      ))}
                    </select>
                    {errors.subProgramId && <span style={s.err}>{errors.subProgramId}</span>}
                  </div>
                )}

                <button type="submit" style={s.btn}
                  onMouseEnter={e => e.target.style.background='#1D4ED8'}
                  onMouseLeave={e => e.target.style.background='#2563EB'}>
                  SIGN UP
                </button>
              </form>

              <p style={s.terms}>
                By submitting, you agree to our{' '}
                <a href="#" style={s.inlineLink}>Terms of Service</a> &{' '}
                <a href="#" style={s.inlineLink}>Privacy Policy</a> and to be contacted via Call/Email/WhatsApp/SMS.
              </p>
              <div style={{ borderTop: '1px solid #E2E8F0', margin: '16px 0 0' }} />
              <p style={{ textAlign: 'center', fontSize: 14, color: '#475569', margin: '14px 0 0' }}>
                Already have an account?{' '}
                <Link to="/login" style={{ ...s.inlineLink, fontSize: 14 }}>Sign in</Link>
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const s = {
  page: {
    minHeight:           '100vh',
    display:             'grid',
    gridTemplateColumns: '1fr 1fr',
    fontFamily:          "'Inter','Segoe UI',sans-serif",
  },

  /* Left */
  left: {
    background:     'linear-gradient(160deg,#0D9488 0%,#0EA5E9 35%,#2563EB 70%,#1D4ED8 100%)',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    padding:        '60px 8%',
  },
  leftInner: { maxWidth: 420 },
  logo:      { height: 44, marginBottom: 36, filter: 'brightness(0) invert(1)' },
  leftH:     { fontSize: 'clamp(26px,3vw,40px)', fontWeight: 800, color: '#fff', letterSpacing: '-0.03em', lineHeight: 1.2, margin: '0 0 16px' },
  leftP:     { fontSize: 16, color: 'rgba(255,255,255,0.82)', lineHeight: 1.7, marginBottom: 32 },
  featureList:{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 36 },
  feature:   { fontSize: 15, color: 'rgba(255,255,255,0.90)', fontWeight: 500 },
  statsRow:  { display: 'flex', gap: 28 },
  stat:      { display: 'flex', flexDirection: 'column', gap: 3 },
  statV:     { fontSize: 28, fontWeight: 800, color: '#fff', letterSpacing: '-0.02em' },
  statL:     { fontSize: 12, color: 'rgba(255,255,255,0.65)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' },

  /* Right */
  right: {
    background:     '#F8FAFC',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    padding:        '48px 40px',
    overflowY:      'auto',
  },
  card: {
    background:    '#FFFFFF',
    borderRadius:  '16px',
    border:        '1px solid #E2E8F0',
    boxShadow:     '0 4px 24px rgba(0,0,0,0.07)',
    padding:       '52px 48px 44px',
    width:         '100%',
    maxWidth:      '520px',
    position:      'relative',
  },
  close:   { position:'absolute', top:16, right:20, fontSize:18, color:'#64748B', textDecoration:'none', lineHeight:1 },
  heading: { fontSize:22, fontWeight:800, color:'#0F172A', letterSpacing:'-0.02em', lineHeight:1.3, margin:'0 0 22px' },
  sub:     { fontSize:13, color:'#64748B', marginBottom:22 },
  inlineLink: { color:'#2563EB', textDecoration:'none', fontWeight:700 },

  form:  { display:'flex', flexDirection:'column', gap:16 },
  row:   { display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 },
  field: { display:'flex', flexDirection:'column', gap:6 },

  input: {
    padding:      '15px 16px',
    border:       '1.5px solid #E2E8F0',
    borderRadius: '10px',
    fontSize:     '15px',
    color:        '#1E293B',
    outline:      'none',
    background:   '#F8FAFC',
    width:        '100%',
    boxSizing:    'border-box',
    transition:   'border-color 0.2s',
  },
  phoneWrap: {
    display:'flex', alignItems:'center',
    border:'1.5px solid #E2E8F0', borderRadius:'10px',
    overflow:'hidden', background:'#F8FAFC', transition:'border-color 0.2s',
  },
  flag: {
    padding:'0 8px', fontSize:12, fontWeight:700, color:'#334155',
    borderRight:'1px solid #E2E8F0', whiteSpace:'nowrap', userSelect:'none',
    background:'#F1F5F9', flexShrink:0,
  },
  eyeWrap: {
    display:'flex', alignItems:'center',
    border:'1.5px solid #E2E8F0', borderRadius:'10px',
    overflow:'hidden', background:'#F8FAFC', transition:'border-color 0.2s',
  },
  eyeBtn:  { background:'none', border:'none', cursor:'pointer', padding:'0 10px', fontSize:15 },

  select: {
    padding:'12px 14px',
    border:'1.5px solid #E2E8F0', borderRadius:'10px',
    fontSize:'14px', color:'#1E293B',
    outline:'none', background:'#F8FAFC', width:'100%', cursor:'pointer',
  },

  btn: {
    marginTop:     4,
    padding:       '14px',
    background:    '#2563EB',
    color:         '#fff',
    border:        'none',
    borderRadius:  '10px',
    fontSize:      '15px',
    fontWeight:    700,
    letterSpacing: '0.08em',
    cursor:        'pointer',
    transition:    'background 0.2s',
    width:         '100%',
  },

  terms: { fontSize:12, color:'#94A3B8', textAlign:'center', margin:'14px 0 0', lineHeight:1.6 },
  err:   { fontSize:11, color:'#EF4444', fontWeight:500 },
};

export default RegisterForm;
